import React, { useEffect, useState } from 'react';
import {
    Modal, ModalOverlay, ModalContent, ModalHeader, ModalCloseButton, ModalBody, ModalFooter,
    Button, Text, Textarea, FormControl, FormLabel, FormHelperText, Alert, AlertIcon, Box,
} from '@chakra-ui/react';

// Confirmacao que exige motivo (desfazer pagamento). onConfirmar(motivo) devolve
// a mensagem de erro, ou null quando deu certo.
const ModalMotivo = ({ isOpen, onClose, titulo, descricao, resumo, confirmText = 'Confirmar', onConfirmar }) => {
    const [motivo, setMotivo] = useState('');
    const [erro, setErro] = useState(null);
    const [enviando, setEnviando] = useState(false);

    useEffect(() => {
        if (isOpen) {
            setMotivo('');
            setErro(null);
        }
    }, [isOpen]);

    const confirmar = async () => {
        if (motivo.trim().length < 5) {
            setErro('Descreva o motivo (pelo menos 5 letras).');
            return;
        }
        setEnviando(true);
        const falha = await onConfirmar(motivo.trim());
        setEnviando(false);
        if (falha) setErro(falha);
    };

    return (
        <Modal isOpen={isOpen} onClose={enviando ? () => {} : onClose} isCentered size={{ base: 'full', sm: 'md' }}>
            <ModalOverlay backdropFilter="blur(2px)" />
            <ModalContent borderRadius={{ base: 0, sm: 'xl' }}>
                <ModalHeader pb={1}>{titulo}</ModalHeader>
                <ModalCloseButton isDisabled={enviando} />
                <ModalBody>
                    {descricao && <Text fontSize="sm" color="gray.600" mb={3}>{descricao}</Text>}
                    {resumo && <Box mb={4}>{resumo}</Box>}
                    <FormControl isRequired>
                        <FormLabel fontSize="sm">Motivo</FormLabel>
                        <Textarea
                            value={motivo}
                            onChange={(e) => { setMotivo(e.target.value); setErro(null); }}
                            maxLength={500}
                            rows={3}
                            placeholder="Ex.: marcado como pago no vendedor errado"
                            isDisabled={enviando}
                            aria-label="Motivo"
                        />
                        <FormHelperText fontSize="xs">Fica registrado no histórico com o seu nome.</FormHelperText>
                    </FormControl>
                    {erro && (
                        <Alert status="error" borderRadius="md" mt={4} fontSize="sm">
                            <AlertIcon />
                            {erro}
                        </Alert>
                    )}
                </ModalBody>
                <ModalFooter gap={2}>
                    <Button variant="ghost" onClick={onClose} isDisabled={enviando}>Cancelar</Button>
                    <Button colorScheme="red" onClick={confirmar} isLoading={enviando} loadingText="Desfazendo">{confirmText}</Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    );
};

export default ModalMotivo;
